import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MainImage from '~/components/atoms/Editorial/MainImage.vue';
export default {
  name: 'ProductCard',
  components: {
    MainImage: MainImage
  },
  props: {
    src: {
      type: String,
      required: true
    },
    srcset: {
      type: String,
      default: ''
    },
    alt: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    reference: {
      type: String,
      default: ''
    },
    stock: {
      type: String,
      default: ''
    },
    price: {
      type: String,
      default: ''
    },
    salePrice: {
      type: String,
      default: ''
    },
    ecopart: {
      type: String,
      default: ''
    },
    quantity: {
      type: String,
      default: ''
    }
  }
};